import { Button } from "../../../../shared/components/ui/Button";
import { FormField } from "../../../../shared/components/forms/FormField";
import { useLifeguardLoginForm } from "./useLifeguardLoginForm";
import type { LifeguardLoginFormProps } from "./LifeguardLoginForm.types";

export const LifeguardLoginForm: React.FC<LifeguardLoginFormProps> = ({
  onLogin,
  isSubmitting,
  buildings,
}) => {
  const {
    onSubmit,
    errors,
    isValid,
    selectedCityId,
    selectedBuildingId,
    citiesOptions,
    buildingsOptions,
    handleCityChange,
    handleBuildingChange,
  } = useLifeguardLoginForm({ onLogin, buildings });

  return (
    <div className="flex flex-col gap-4 w-full max-w-sm">
      <h1 className="text-2xl font-bold">Selecciona tu unidad residencial</h1>

      <form onSubmit={onSubmit} className="flex flex-col gap-4">
        {/* Ciudad */}
        <FormField
          type="searchableSelect"
          label="Ciudad"
          required
          searchableSelectProps={{
            options: citiesOptions,
            placeholder: "Buscar ciudad...",
            name: "city_id",
            value: selectedCityId,
            onChange: handleCityChange,
            onBlur: () => {}, // Handle blur if needed
          }}
          error={errors.city_id?.message}
        />

        {/* Unidad Residencial */}
        <FormField
          type="searchableSelect"
          label="Unidad Residencial"
          required
          searchableSelectProps={{
            options: buildingsOptions,
            placeholder: selectedCityId ? "Buscar unidad residencial..." : "Primero selecciona una ciudad",
            disabled: !selectedCityId,
            name: "building_id",
            value: selectedBuildingId,
            onChange: handleBuildingChange,
            onBlur: () => {}, // Handle blur if needed
          }}
          error={errors.building_id?.message}
        />

        {/* Submit */}
        <Button type="submit" disabled={!isValid || isSubmitting}>
          {isSubmitting ? "Iniciando sesión..." : "Iniciar sesión"}
        </Button>
      </form>
    </div>
  );
};

